import { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
    MdEdit,
    MdDelete,
    MdClose,
    MdOutlineCloudDownload,
} from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { BsFiletypeDocx, BsFiletypeXlsx, BsFiletypePdf } from "react-icons/bs";

import logo from "../../assets/logo.png";
import "./css/task.css";

import { AppContext } from "../../Context";
import Paging from "./components/paging";
import Question from "./components/question";
import QuestionAdd from "../popups/QuestionAdd";
import QuestionsList from "./components/questionsList";
import Header from "./Header";
import {
    Input,
    SelectBox,
    ClassesDropdown,
    RichText,
    UploadForm,
    HiddenUpload,
} from "../../components/Form";
import Fetch, { Loader, GET } from "../../inc/Fetch";
import Permission from "../Permission";
import { Config } from "../../inc/Config";

export default function Task({ action }) {
    const { t } = useTranslation();
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    let taskCk = true;
    const lastPath = location?.pathname?.split("/")[1];
    if (lastPath != "lesson") {
        taskCk = false;
    }

    const { successData, userData, siteData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    const [site, setsite] = siteData;

    const [steps, setsteps] = useState(1);
    const [Open, setOpen] = useState();

    const [loading, setloading] = useState(false);
    const [loader, setloader] = useState(true);

    const [cats, setcats] = useState([]);
    const [colors, setcolors] = useState({});

    const [values, setvalues] = useState([]);
    const [questions, setquestions] = useState([]);
    const [files, setfiles] = useState([]);

    if (!params?.cat) {
        return false;
    }

    async function loadData() {
        let cats = site?.cats?.filter((r) => r?.name == params?.cat);
        cats = cats?.length ? cats[0] : {};

        if (!cats?._id) {
            return false;
        }

        setcolors(cats?.colors);

        let r = await GET(`task/edit${params?.id ? `?id=${params?.id}` : ""}`);

        setvalues(r?.task);
        setquestions(r?.task?.questions);
        setfiles(r?.task?.files);
        setloader(false);

        setvalues((p) => ({
            ...p,
            cat: { name: cats?.name, _id: cats?._id },
        }));

        let catsList = [{ name: "--", _id: false }];
        cats?.subs?.map((v) => {
            catsList.push(v);
        });

        setcats(catsList);
    }

    function submit() {
        // setloading(true);

        Fetch(
            "task/add",
            (d) => {
                if (d?.error) {
                    setopen({
                        error: true,
                        short: t("error", { returnObjects: true })[d?.error],
                    });
                } else {
                    setopen({ error: false });
                    setTimeout(() => {
                        navigate(`/task/${d?.success?._id}`);
                    }, 2500);
                }

                setloading(false);
            },
            {
                values: values,
                questions: questions,
                files: files,
                lesson: taskCk,
            },
        );
    }

    function stepsCheck(d) {
        if (d == 2) {
            if (!values?.img?.length) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[6],
                });
                return false;
            }

            if (!values?.title) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[4],
                });
                return false;
            }

            if (!values?.subject?._id) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[3],
                });
                return false;
            }

            if (!values?.cat?._id) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[3],
                });
                return false;
            }

            if (!values?.classes?.length) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[5],
                });
                return false;
            }
        } else if (d == 4) {
            if (!values?.story) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[7],
                });
                return false;
            }
        }
        setsteps(d);
    }

    function addFiles(d) {
        if (!d?.length) {
            return false;
        }

        let arr = [];
        d?.map((v) => {
            let fileName = v?.split("/")?.pop();
            arr.push({
                file: v,
                date: new Date(),
                title: fileName ? fileName?.split(".")[0] : "",
            });
        });

        setfiles((p) => (p?.length ? [...p, ...arr] : arr));
    }

    function changeFiles(key, v) {
        setfiles((p) => {
            let arr = [];
            p?.map((vv, kk) => {
                if (key == kk) {
                    vv.title = v;
                }
                arr.push(vv);
            });
            return arr;
        });
    }

    function deleteFile(k) {
        const conf = window.confirm(t("error", { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setfiles((p) => p?.filter((rr, kk) => kk != k));
    }

    useEffect(() => {
        loadData();
    }, []);

    if (loader) {
        return <Loader />;
    }

    if (userinfo?.userlevel < 3) {
        return <Permission />;
    }

    if (userinfo?.userlevel <= 5) {
        if (params?.id && userinfo?._id != values?.user?._id) {
            return <Permission />;
        }
    }

    const regex = /(<([^>]+)>)/gi;

    return (
        <>
            <div className="taskNewBody" style={{ padding: 0 }}>
                <Header
                    title={t(params?.id ? "tasks_edit_new" : "tasks_add_new")}
                />
                {loading && <Loader />}
                {Open && (
                    <QuestionAdd
                        setOpen={setOpen}
                        Open={Open}
                        setquestions={setquestions}
                    />
                )}
                <div
                    className={`taskBody addTask step${steps}`}
                    style={{ justifyContent: "center" }}
                >
                    <a onClick={() => navigate(-1)} className="close">
                        <MdClose />
                    </a>
                    <div className="newTaskForm box1">
                        <h1
                            style={{
                                backgroundColor: colors
                                    ? colors["--menu-color"]
                                    : "#333",
                            }}
                        >
                            {t("task_new_title")}
                        </h1>

                        <div className="form">
                            <UploadForm
                                boxClass="imgCenterUpload"
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        img: d,
                                    }))
                                }
                                value={values?.img ? [values?.img] : []}
                            />
                            <Input
                                validate={true}
                                title={t("task_new_name")}
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        title: d,
                                    }))
                                }
                                value={values?.title}
                            />

                            <SelectBox
                                validate={true}
                                title={t("subject")}
                                values={cats}
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        subject: d,
                                    }))
                                }
                                value={values?.subject}
                            />

                            <ClassesDropdown
                                validate={true}
                                type="classes"
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        classes: d,
                                    }))
                                }
                                value={values?.classes}
                            />

                            <div style={{ display: "flex", gap: 10 }}>
                                <button
                                    onClick={() => stepsCheck(2)}
                                    style={{
                                        backgroundColor: colors
                                            ? colors["--menu-color"]
                                            : "#333",
                                    }}
                                    className="btn"
                                >
                                    {t("next")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="newTaskForm box2">
                        <h1
                            style={{
                                backgroundColor: colors
                                    ? colors["--menu-color"]
                                    : "#333",
                            }}
                        >
                            {t("task_attached_files")}
                        </h1>

                        <div className="form">
                            <label className="attachedFilexBox">
                                <IoDocumentTextOutline />
                                <span>{t("choose_file")}</span>
                                <HiddenUpload
                                    onChange={(d) => addFiles(d)}
                                    multiple={true}
                                    accept={
                                        ".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx"
                                    }
                                />
                            </label>

                            {files?.length ? (
                                <table className="table attached">
                                    <thead>
                                        <tr>
                                            <td style={{ width: 80 }}>
                                                {t("file")}
                                            </td>
                                            <td className="text-right">
                                                {t("title")}
                                            </td>
                                            <td style={{ width: 70 }}>
                                                {t("delete")}
                                            </td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {files?.map((v, k) => {
                                            let ext = v?.file
                                                ?.split(".")
                                                ?.pop();
                                            let FileIco = () => (
                                                <MdOutlineCloudDownload className="attachIco" />
                                            );
                                            if (ext == "doc" || ext == "docx") {
                                                FileIco = () => (
                                                    <BsFiletypeDocx className="attachIco" />
                                                );
                                            } else if (
                                                ext == "xls" ||
                                                ext == "xlsx"
                                            ) {
                                                FileIco = () => (
                                                    <BsFiletypeXlsx className="attachIco" />
                                                );
                                            } else if (ext == "pdf") {
                                                FileIco = () => (
                                                    <BsFiletypePdf className="attachIco" />
                                                );
                                            }

                                            return (
                                                <tr key={k}>
                                                    <td>
                                                        <a
                                                            target="_blank"
                                                            href={
                                                                Config?.imgUrl +
                                                                v?.file
                                                            }
                                                        >
                                                            <FileIco />
                                                        </a>
                                                    </td>
                                                    <td className="text-right">
                                                        <input
                                                            type="text"
                                                            onFocus={(d) =>
                                                                d.target.select()
                                                            }
                                                            placeholder={`${t("title")}..`}
                                                            onChange={(d) =>
                                                                changeFiles(
                                                                    k,
                                                                    d?.target
                                                                        ?.value,
                                                                )
                                                            }
                                                            value={v?.title}
                                                        />
                                                    </td>
                                                    <td>
                                                        <a
                                                            onClick={() =>
                                                                deleteFile(k)
                                                            }
                                                            className="btn red"
                                                        >
                                                            <MdDelete />
                                                        </a>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                false
                            )}

                            <div style={{ display: "flex", gap: 5 }}>
                                <button
                                    onClick={() => stepsCheck(1)}
                                    style={{ flex: "unset" }}
                                    className="btn prev gray"
                                >
                                    <FaArrowRight />
                                </button>
                                <button
                                    onClick={() => stepsCheck(3)}
                                    style={{
                                        backgroundColor: colors
                                            ? colors["--menu-color"]
                                            : "#333",
                                    }}
                                    className="btn"
                                >
                                    {t("next")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="newTaskForm box3">
                        <h1
                            style={{
                                backgroundColor: colors
                                    ? colors["--menu-color"]
                                    : "#333",
                            }}
                        >
                            {t("task_new_text")}
                        </h1>

                        <div className="form">
                            <RichText
                                toolbar="bold italic fontsize forecolor styles | bullist numlist removeformat | video imgs mp3  "
                                height={500}
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        story: d,
                                    }))
                                }
                                value={values?.story}
                            />

                            <div style={{ display: "flex", gap: 5 }}>
                                <button
                                    onClick={() => stepsCheck(2)}
                                    style={{ flex: "unset" }}
                                    className="btn prev gray"
                                >
                                    <FaArrowRight />
                                </button>
                                <button
                                    onClick={() => stepsCheck(4)}
                                    style={{
                                        backgroundColor: colors
                                            ? colors["--menu-color"]
                                            : "#333",
                                    }}
                                    className="btn"
                                >
                                    {t("next")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="newTaskForm box4">
                        <h1
                            style={{
                                backgroundColor: colors
                                    ? colors["--menu-color"]
                                    : "#333",
                            }}
                        >
                            {t("tasks_send_notes")}
                        </h1>

                        <div className="form">
                            <RichText
                                toolbar="bold fontsize forecolor styles | bullist numlist | video imgs "
                                height={400}
                                onChange={(d) =>
                                    setvalues((p) => ({
                                        ...p,
                                        notes: d,
                                    }))
                                }
                                value={values?.notes}
                            />

                            <div style={{ display: "flex", gap: 5 }}>
                                <button
                                    onClick={() => stepsCheck(3)}
                                    style={{ flex: "unset" }}
                                    className="btn prev gray"
                                >
                                    <FaArrowRight />
                                </button>
                                <button
                                    onClick={() => stepsCheck(5)}
                                    style={{
                                        backgroundColor: colors
                                            ? colors["--menu-color"]
                                            : "#333",
                                    }}
                                    className="btn"
                                >
                                    {t("next")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="newTaskForm box5">
                        <h1
                            style={{
                                backgroundColor: colors
                                    ? colors["--menu-color"]
                                    : "#333",
                            }}
                        >
                            {t("task_new_question")}
                        </h1>

                        <div className="form">
                            <button
                                onClick={() => setOpen(true)}
                                className="btn gray newq"
                            >
                                {t("task_new_add_question")}
                            </button>

                            <div className="newQuestionsBox">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <td style={{ width: 30 }}>#</td>
                                            <td className="text-right">
                                                {t("task_question")}
                                            </td>
                                            <td style={{ width: 110 }}>
                                                {t("task_type")}
                                            </td>
                                            <td style={{ width: 120 }}>
                                                {t("edit")}
                                            </td>
                                        </tr>
                                    </thead>

                                    {questions?.length ? (
                                        <tbody>
                                            {questions?.map((v, k) => {
                                                return (
                                                    <QuestionsList
                                                        v={v}
                                                        k={k + 1}
                                                        key={k}
                                                        setOpen={setOpen}
                                                        setquestions={
                                                            setquestions
                                                        }
                                                    />
                                                );
                                            })}
                                        </tbody>
                                    ) : (
                                        false
                                    )}
                                </table>

                                {!questions?.length ? (
                                    <div className="no_data">
                                        {t("error", { returnObjects: true })[1]}
                                    </div>
                                ) : (
                                    false
                                )}
                            </div>

                            <div style={{ display: "flex", gap: 5 }}>
                                <button
                                    onClick={() => stepsCheck(4)}
                                    style={{ flex: "unset" }}
                                    className="btn prev gray"
                                >
                                    <FaArrowRight />
                                </button>
                                <button
                                    onClick={submit}
                                    style={{
                                        flex: 1,
                                        backgroundColor: colors
                                            ? colors["--menu-color"]
                                            : "#333",
                                    }}
                                    className="btn"
                                >
                                    {taskCk
                                        ? t("task_save_les")
                                        : t("task_save_task")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
